<template>
  <div class="l-container-inner">
    <ShopItem v-for="item in this.shopitems.slice().reverse()" :key="item.id" :shopitem='shopitems[item.id]'></ShopItem>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import ShopItem from '@/components/ShopItem'

export default {
  name: 'Shop',
  computed: {
    ...mapGetters(['getShopItems']),
    shopitems () {
      return this.getShopItems
    }
  },
  components: {
    ShopItem
  }
}
</script>

<style scoped lang='scss'>
.white {
  background: #fff !important;
  color: #000;
}
</style>



// WEBPACK FOOTER //
// src/views/Shop.vue